import { createContext } from 'react';

/**
 * Heading number → "eCTD publishing note (for your publisher): v3.2.2 …; v4.0 …" line
 * (`ectdVersionNotes`), read by `EctdVersionNote`. Only `EctdRenderer` provides it, and only for
 * the five U.S. medicinal types; everywhere else (the EU CTD view, eSTAR) the default empty map
 * means no note and unchanged output.
 */
export const EctdVersionNotesContext = createContext<ReadonlyMap<string, string>>(new Map());
